import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
 
let duration = 400;
 

const I1 = "https://www.winpeforum.com/assets/wob/13feb2026/1.jpg";
 
 

 
 

const II1 = "https://www.winpeforum.com/download.php?file=assets/wob/13feb2026/1.jpg";
 

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
     
    

    
    this.CollegiumsImages = [
      { id:23, ImgSrc: I1, ImgSrc1: II1,},   
      
       
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
         <Meta
          title="Women on Boards"
          image={"https://winpeforum.com/assets/wob/banner.jpg"}
          description="Winpe’s Women on Boards initiative hosted another exceptional session marked by profound insights, engaging discussions, and inspiring connections. We are pleased to report that the session received outstanding evaluations—100% of participants acknowledged significant knowledge gains, and our speakers were rated exceptionally well at 4.5."
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left">Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">      Winpe Women on Boards | Self-Led Series<br/>
  Session I: Learning from the Recent Civil Aviation Crisis

  </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                 <span> 
       February 13th, 2026 (04:30 - 5:30 PM IST)<br/>
     Format- Virtual (Zoom)</span>
                </div>
              </div>
              <br/>     
              
              <div className="top_text" style={{textAlign:'justify'}}>
           
 
<p> Winpe WoB Self-Led Sessions are thoughtfully designed to create a dedicated space for senior women leaders to engage in reflective, self-directed learning. Grounded in peer exchange and real-world governance contexts, these sessions foster open dialogue, diverse perspectives, and candid reflections. <br/><br/>
The first session examined the recent civil aviation disruption in India arising from the grounding of a significant number of flights by the country’s leading airline. Drawing exclusively on publicly available information, the discussion explored how regulatory change, organisational scale, and growth pressures can converge into a systemic challenge, and considered the role a board of directors could reasonably play in anticipating, mitigating, and responding to such situations. <br/><br/>
Participants reflected on what this episode reveals about board oversight, risk governance, organisational resilience, and the role of regulatory bodies with insights extending well beyond the aviation sector. Consistent with the self-led philosophy, the session was facilitated and discussion-based, centred on shared reflection rather than instruction, with no formal presentations—only thoughtful dialogue shaped by collective experience.<br/><br/>
The session received excellent feedback, with all participants describing the experience as engaging, insightful, and highly relevant for board-level learning. <br/><br/>
Note: The session was conducted under Chatham House Rules and no recording was made.


</p>


   


 

              </div>
              
             
              <div className="container">
                    <div>
                      <Heading title="Gallery" />
                    </div>
                   <center> <div className="row"  style={{ width: '65%' }}>
                      {this.CollegiumsImages.map((item, j) => {
                        return (
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{padding: '8px'}}>
                            <div className="img_card">
                            <img style={{width:'100%'}} src={item.ImgSrc} alt="Winpe sheshines" />
                            <a href={item.ImgSrc1} > <i style={{color:'white', position:'absolute', left:'20px', top:'20px'}} class="fa fa-2x  fa-download "></i></a> 
                            </div>
                          </div>
                        );
                      })}
                    </div></center>
                  </div>
                 <br/>
  <br/> 
   
<div class="container">
<br/>
 
 
 </div>
       
          <br/><br/>
     
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/WOBSelf-Led-Series-Session1/index.js